/* RE-Tech redesign — storefront interactions (vanilla, no deps) */
(function () {
  "use strict";
  function rtTrack(eventName, details) {
    var payload = Object.assign({ event: eventName }, details || {});
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
    window.dispatchEvent(new CustomEvent("retech:" + eventName, { detail: payload }));
  }
  function ready(fn) { if (document.readyState !== "loading") fn(); else document.addEventListener("DOMContentLoaded", fn); }
  ready(function () {
    var revealEls = document.querySelectorAll(".rt .reveal");
    if ("IntersectionObserver" in window && revealEls.length) {
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var pending = [];
      revealEls.forEach(function (el, i) {
        var r = el.getBoundingClientRect();
        if (r.top < vh * 0.98 && r.bottom > 0) {
          el.style.transitionDelay = (Math.min(pending.length === 0 ? i % 8 : 0, 6) * 45) + "ms";
          el.classList.add("in");
        } else {
          el.style.transitionDelay = (Math.min(i % 8, 6) * 45) + "ms";
          pending.push(el);
        }
      });
      var io = new IntersectionObserver(function (ents) {
        ents.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add("in"); io.unobserve(e.target); } });
      }, { threshold: 0.05, rootMargin: "0px 0px -4% 0px" });
      pending.forEach(function (el) { io.observe(el); });
      window.addEventListener("pageshow", function () { revealEls.forEach(function (el) { var r = el.getBoundingClientRect(); if (r.top < vh && r.bottom > 0) el.classList.add("in"); }); });
    } else { revealEls.forEach(function (el) { el.classList.add("in"); }); }

    var header = document.querySelector(".rt-header");
    if (header) { var onScroll = function () { header.classList.toggle("scrolled", window.scrollY > 16); }; window.addEventListener("scroll", onScroll, { passive: true }); onScroll(); }

    var burger = document.querySelector(".rt-burger");
    var mobile = document.querySelector(".rt-mobile-menu");
    if (burger && mobile) { burger.addEventListener("click", function () { mobile.classList.toggle("open"); }); }

    document.querySelectorAll(".rt-faq-item").forEach(function (item) {
      var q = item.querySelector(".rt-faq-q");
      var answer = item.querySelector(".rt-faq-a");
      if (q) q.addEventListener("click", function () {
        var wasOpen = item.classList.contains("open");
        var parent = item.parentElement;
        if (parent) parent.querySelectorAll(".rt-faq-item.open").forEach(function (o) {
          o.classList.remove("open");
          var otherButton = o.querySelector(".rt-faq-q");
          var otherAnswer = o.querySelector(".rt-faq-a");
          if (otherButton) otherButton.setAttribute("aria-expanded", "false");
          if (otherAnswer) otherAnswer.hidden = true;
        });
        if (!wasOpen) {
          item.classList.add("open");
          q.setAttribute("aria-expanded", "true");
          if (answer) answer.hidden = false;
        }
      });
    });

    document.querySelectorAll("[data-rt-tabs]").forEach(function (group) {
      var tabs = group.querySelectorAll(".rt-tab");
      var panels = group.querySelectorAll(".rt-tabpanel");
      function activateTab(tab, focus) {
        tabs.forEach(function (t) {
          var selected = t === tab;
          t.classList.toggle("on", selected);
          t.setAttribute("aria-selected", selected ? "true" : "false");
          t.setAttribute("tabindex", selected ? "0" : "-1");
        });
        panels.forEach(function (p) {
          var selected = p.getAttribute("data-panel") === tab.getAttribute("data-tab");
          p.classList.toggle("on", selected);
          p.hidden = !selected;
        });
        if (focus) tab.focus();
      }
      tabs.forEach(function (tab) {
        tab.addEventListener("click", function () { activateTab(tab, false); });
        tab.addEventListener("keydown", function (event) {
          if (event.key !== "ArrowRight" && event.key !== "ArrowLeft" && event.key !== "Home" && event.key !== "End") return;
          event.preventDefault();
          var index = Array.prototype.indexOf.call(tabs, tab);
          if (event.key === "Home") index = 0;
          else if (event.key === "End") index = tabs.length - 1;
          else index = (index + (event.key === "ArrowRight" ? 1 : -1) + tabs.length) % tabs.length;
          activateTab(tabs[index], true);
        });
      });
    });

    document.querySelectorAll("[data-rt-qty]").forEach(function (wrap) {
      var val = wrap.querySelector(".val");
      var input = document.querySelector(wrap.getAttribute("data-rt-qty"));
      var n = 1;
      wrap.querySelectorAll("button").forEach(function (b) {
        b.addEventListener("click", function () { n = Math.max(1, n + (b.getAttribute("data-step") === "up" ? 1 : -1)); if (val) val.textContent = n; if (input) input.value = n; });
      });
    });

    document.querySelectorAll("[data-rt-variants]").forEach(function (wrap) {
      var select = document.querySelector(wrap.getAttribute("data-rt-variants"));
      wrap.querySelectorAll(".rt-vbtn").forEach(function (btn) {
        btn.addEventListener("click", function () {
          wrap.querySelectorAll(".rt-vbtn").forEach(function (b) { b.classList.remove("on"); b.setAttribute("aria-pressed", "false"); });
          btn.classList.add("on");
          btn.setAttribute("aria-pressed", "true");
          if (select) { select.value = btn.getAttribute("data-variant-id"); select.dispatchEvent(new Event("change")); }
          var productRoot = wrap.closest('[data-rt-product-root]');
          var tradeLink = productRoot && productRoot.querySelector('[data-rt-trade-link]');
          if (tradeLink && select && select.selectedIndex >= 0) {
            var tradeUrl = new URL(tradeLink.href, location.origin);
            tradeUrl.searchParams.set('upgrade', tradeLink.getAttribute('data-product-title') + ' — ' + select.options[select.selectedIndex].text);
            tradeLink.href = tradeUrl.toString();
          }
        });
      });
    });

    function showCartError() {
      var el=document.querySelector('[data-rt-cart-error]');
      if(el){el.hidden=false;el.focus();}
    }
    var toast = document.querySelector(".rt-toast");
    function showToast() { if (!toast) return; toast.classList.add("show"); clearTimeout(window.__rtToast); window.__rtToast = setTimeout(function () { toast.classList.remove("show"); }, 2600); }
    function rtUpdateCount() { fetch("/cart.js").then(function (r) { return r.json(); }).then(function (cart) { document.querySelectorAll("[data-rt-cart-count]").forEach(function (el) { el.textContent = cart.item_count; el.style.display = cart.item_count > 0 ? "" : "none"; }); }).catch(function () {}); }

    document.querySelectorAll("form[data-rt-cart-form]").forEach(function (form) {
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        if(form.dataset.pending === "true") return;
        form.dataset.pending = "true";
        var btn = form.querySelector('[type="submit"]');
        if (btn) btn.setAttribute("disabled", "disabled");
        fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", "Accept": "application/json" }, body: JSON.stringify(serialize(form)) })
          .then(function (r) { if (!r.ok) throw new Error("Cart request failed"); return r.json(); })
          .then(function () { showToast(); rtUpdateCount(); rtTrack("add_to_cart", { source: "product_form" }); })
          .catch(function () { showCartError(); })
          .finally(function () { form.dataset.pending = "false"; if (btn) btn.removeAttribute("disabled"); });
      });
    });
    var contactForm = document.querySelector(".rt-contact form");
    if (contactForm) {
      try {
        var requestedProduct = new URLSearchParams(window.location.search).get("product");
        var contactMessage = contactForm.querySelector('textarea[name="contact[body]"]');
        if (requestedProduct && contactMessage && !contactMessage.value.trim()) contactMessage.value = "Запитване: " + requestedProduct + "\nВариант: " + (new URLSearchParams(location.search).get("variant") || "—") + "\nVariant ID: " + (new URLSearchParams(location.search).get("variant_id") || "—") + "\nОриентировъчна цена: " + (new URLSearchParams(location.search).get("price") || "за потвърждение") + "\n\n";
      } catch (ignoreParams) {}
      contactForm.addEventListener("submit", function () { rtTrack("contact_form_submit", { source: "contact_page" }); });
    }
    function serialize(form) {
      var data = { items: [] }, id = form.querySelector('[name="id"]'), qty = form.querySelector('[name="quantity"]');
      if (id) data.items.push({ id: parseInt(id.value, 10), quantity: qty ? parseInt(qty.value, 10) || 1 : 1 });
      return data;
    }

    document.addEventListener("click", function (e) {
      var qa = e.target.closest ? e.target.closest("[data-rt-quickadd]") : null;
      if (!qa || qa.disabled) return;
      e.preventDefault();
      var id = qa.getAttribute("data-variant-id"); if (!id) return;
      qa.setAttribute("disabled", "disabled");
      fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", "Accept": "application/json" }, body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: 1 }] }) })
        .then(function (r) { if (!r.ok) throw new Error("Cart request failed"); return r.json(); })
        .then(function () { showToast(); rtUpdateCount(); rtTrack("add_to_cart", { source: "product_card", variant_id: id }); })
        .catch(function () { showCartError(); })
        .finally(function () { qa.removeAttribute("disabled"); });
    });

    var wiz = document.querySelector("[data-rt-wizard]");
    if (wiz) initWizard(wiz);
    function initWizard(root) {
      var marketIndex = [];
      var marketData = root.querySelector("[data-rt-market-index]");
      try { marketIndex = marketData ? JSON.parse(marketData.textContent || "[]") : []; } catch (ignore) { marketIndex = []; }
      var sellLabels = {};
      try { sellLabels = JSON.parse(root.querySelector('[data-rt-sell-labels]').textContent); } catch (ignoreLabels) {}
      var vramInput = root.querySelector('[data-rt-field=rt_vram]');
      var faultsInput = root.querySelector('[data-rt-field=rt_faults]');
      [vramInput, faultsInput].forEach(function (input) { if (input) input.addEventListener('change', function () { updateReference(); updateNav(); }); });
      var buybackRate = parseFloat(root.getAttribute("data-buyback-rate")) || 0.68;
      var offerSpread = parseFloat(root.getAttribute("data-offer-spread")) || 0.07;
      var state = { step: 0, type: null, typeLabel: "", cond: null, condLabel: "", mul: 1, reference: null };
      var gpuModelFamilies = [
        "NVIDIA GeForce RTX 3050", "NVIDIA GeForce RTX 3060", "NVIDIA GeForce RTX 3060 Ti", "NVIDIA GeForce RTX 3070", "NVIDIA GeForce RTX 3070 Ti", "NVIDIA GeForce RTX 3080", "NVIDIA GeForce RTX 3080 Ti", "NVIDIA GeForce RTX 3090", "NVIDIA GeForce RTX 3090 Ti",
        "NVIDIA GeForce RTX 4060", "NVIDIA GeForce RTX 4060 Ti", "NVIDIA GeForce RTX 4070", "NVIDIA GeForce RTX 4070 Super", "NVIDIA GeForce RTX 4070 Ti", "NVIDIA GeForce RTX 4070 Ti Super", "NVIDIA GeForce RTX 4080", "NVIDIA GeForce RTX 4080 Super", "NVIDIA GeForce RTX 4090",
        "NVIDIA GeForce RTX 5050", "NVIDIA GeForce RTX 5060", "NVIDIA GeForce RTX 5060 Ti", "NVIDIA GeForce RTX 5070", "NVIDIA GeForce RTX 5070 Ti", "NVIDIA GeForce RTX 5080", "NVIDIA GeForce RTX 5090",
        "AMD Radeon RX 7400", "AMD Radeon RX 7600", "AMD Radeon RX 7600 XT", "AMD Radeon RX 7700", "AMD Radeon RX 7700 XT", "AMD Radeon RX 7800 XT", "AMD Radeon RX 7900 GRE", "AMD Radeon RX 7900 XT", "AMD Radeon RX 7900 XTX",
        "AMD Radeon RX 9050", "AMD Radeon RX 9060", "AMD Radeon RX 9060 XT", "AMD Radeon RX 9070", "AMD Radeon RX 9070 GRE", "AMD Radeon RX 9070 XT"
      ];
      var steps = root.querySelectorAll(".rt-wizard-step");
      var bar = root.querySelector(".rt-progress-bar");
      var counter = root.querySelector("[data-step-counter]");
      var rail = document.querySelectorAll(".rt-rail-step");
      var nextBtn = root.querySelector("[data-rt-next]");
      var backBtn = root.querySelector("[data-rt-back]");
      var sellForm = root.querySelector("form");
      var finalSubmitting = false;
      var lastTrackedStep = -1;
      var errEl = root.querySelector("[data-rt-error]");
      var modelInput = root.querySelector("[data-rt-field=rt_model]");
      var modelList = root.querySelector("[data-rt-model-list]");
      var modelHint = root.querySelector("[data-model-hint]");
      var errData = document.querySelector("[data-rt-form-errors]");
      if (errData && errEl) { errEl.style.display = ""; errEl.textContent = "Възникна проблем при изпращането: " + (errData.getAttribute("data-errors") || "опитай отново."); }
      root.querySelectorAll("[data-type]").forEach(function (b) {
        b.addEventListener("click", function () {
          root.querySelectorAll("[data-type]").forEach(function (x) { x.classList.remove("on"); x.setAttribute("aria-pressed", "false"); });
          b.classList.add("on"); b.setAttribute("aria-pressed", "true"); state.type = b.getAttribute("data-type"); state.typeLabel = b.getAttribute("data-label");
          refreshModelList(); updateReference(); updateNav();
        });
      });
      root.querySelectorAll("[data-cond]").forEach(function (b) {
        b.addEventListener("click", function () {
          root.querySelectorAll("[data-cond]").forEach(function (x) { x.classList.remove("on"); x.setAttribute("aria-pressed", "false"); });
          b.classList.add("on"); b.setAttribute("aria-pressed", "true"); state.cond = b.getAttribute("data-cond"); state.condLabel = b.getAttribute("data-label"); state.mul = parseFloat(b.getAttribute("data-mul")); updateReference(); updateNav();
        });
      });
      root.querySelectorAll(".rt-input").forEach(function (inp) { inp.addEventListener("input", updateNav); });
      var consentInput = root.querySelector("[data-sell-consent]");
      if (consentInput) consentInput.addEventListener("change", updateNav);
      if (modelInput) modelInput.addEventListener("input", updateReference);
      function val(sel) { var el = root.querySelector(sel); return el ? el.value.trim() : ""; }
      function setHidden(sel, v) { var el = root.querySelector(sel); if (el) {el.value = v;el.setAttribute("value",v);} }
      function normalize(value) { return (value || "").toLowerCase().replace(/[^a-z0-9а-я]+/g, " ").trim().replace(/\s+/g, " "); }
      function itemType(item) {
        var type = normalize(item && item.type);
        if (type.indexOf("видеокарт") > -1 || type.indexOf("gpu") > -1 || type.indexOf("graphics card") > -1) return "gpu";
        if (type.indexOf("процесор") > -1 || type.indexOf("cpu") > -1) return "cpu";
        if (type.indexOf("ram") > -1 || type.indexOf("памет") > -1) return "ram";
        if (type.indexOf("ssd") > -1 || type.indexOf("storage") > -1) return "ssd";
        if (type.indexOf("дънна") > -1 || type.indexOf("motherboard") > -1) return "mb";
        if (type.indexOf("pc конфигура") > -1 || type.indexOf("computer") > -1 || type.indexOf("system") > -1) return "pc";
        return "";
      }
      function typeMatches(item) { var knownType = itemType(item); return !knownType || !state.type || knownType === state.type; }
      function refreshModelList() {
        var vramField = root.querySelector('[data-sell-vram-field]');
        if (vramField) vramField.hidden = state.type !== 'gpu';
        if (!modelList) return;
        modelList.innerHTML = "";
        var suggestions = state.type === "gpu"
          ? gpuModelFamilies
          : marketIndex.filter(typeMatches).map(function (item) { return item.title || ""; });
        suggestions.filter(Boolean).forEach(function (title) {
          var option = document.createElement("option");
          option.value = title;
          modelList.appendChild(option);
        });
      }
      function modelKey(value) {
        var text = normalize(value);
        var nvidia = text.match(/\b(rtx|gtx)\s*(\d{4})\s*(ti)?\s*(super|s)?\b/i);
        if (nvidia) return nvidia[1].toLowerCase() + nvidia[2] + (nvidia[3] ? "ti" : "") + (nvidia[4] ? "s" : "");
        var amd = text.match(/\brx\s*(\d{4})\s*(xtx|xt|gre)?\b/i);
        if (amd) return "rx" + amd[1] + (amd[2] ? amd[2].toLowerCase() : "");
        var cpu = text.match(/ryzen\s*[3579]\s*\d{4,5}[a-z0-9]*|(?:intel\s*)?(?:core\s*)?i[3579]\s*-?\s*\d{4,5}[a-z0-9]*/i);
        return cpu ? normalize(cpu[0]).replace(/\s/g, "") : "";
      }
      function priceInEur(item) {
        var indexedPrice = parseFloat(item.marketPriceEur);
        if (indexedPrice > 0) return { value: indexedPrice, source: "Вътрешна EUR база" };
        var catalogPrice = (parseFloat(item.priceMinor) || 0) / 100;
        if (!catalogPrice) return null;
        return { value: catalogPrice, source: "Каталожна EUR цена" };
      }
      function vramCapacity(value) {
        var match = (value || '').match(/\b(\d{1,2})\s*(?:gb|гб)\b/i);
        return match ? Number(match[1]) : null;
      }
      function findReference(model) {
        var wanted = normalize(model);
        if (!wanted || state.cond === 'd' || val('[data-rt-field=rt_faults]') === 'yes') return null;
        var titleCapacity = vramCapacity(model);
        var selectedCapacity = state.type === 'gpu' ? Number(val('[data-rt-field=rt_vram]')) || null : null;
        if (state.type === 'gpu' && titleCapacity && selectedCapacity && titleCapacity !== selectedCapacity) return null;
        var capacity = selectedCapacity || titleCapacity;
        if (state.type === 'gpu' && !capacity && ['rtx3050', 'rtx3060', 'rtx3080', 'rtx4060ti', 'rtx5060ti', 'rx9060xt'].includes(modelKey(model))) return null;
        var compatible = marketIndex.filter(typeMatches);
        var matches = compatible.filter(function (item) { return normalize(item.title) === wanted; });
        var key = modelKey(model);
        if (!matches.length && key) matches = compatible.filter(function (item) { return modelKey(item.title) === key; });
        if (!matches.length && wanted.length >= 6 && state.type !== "gpu") matches = compatible.filter(function (item) {
          var title = normalize(item.title); return title.indexOf(wanted) > -1 || wanted.indexOf(title) > -1;
        });
        if (state.type === 'gpu' && capacity) matches = matches.filter(function (item) { return vramCapacity(item.title) === capacity; });
        var priced = matches.map(function (item) {
          var price = priceInEur(item); return price ? { item: item, price: price } : null;
        }).filter(Boolean).sort(function (a, b) { return a.price.value - b.price.value; });
        if (!priced.length) return null;
        var middle = Math.floor(priced.length / 2);
        var value = priced.length % 2 ? priced[middle].price.value : (priced[middle - 1].price.value + priced[middle].price.value) / 2;
        var indexed = priced.some(function (match) { return match.price.source === "Вътрешна EUR база"; });
        return {
          title: key ? key.toUpperCase() + (state.type === "gpu" && capacity ? " " + capacity + "GB" : "") : priced[0].item.title,
          value: value,
          count: priced.length,
          source: indexed ? "Вътрешна EUR база" : "Каталожна EUR цена"
        };
      }
      function updateReference() {
        state.reference = findReference(val("[data-rt-field=rt_model]"));
        if (!modelHint) return;
        if (state.reference) modelHint.textContent = (sellLabels.auto || "__MODEL__").replace("__MODEL__", state.reference.title);
        else if (val("[data-rt-field=rt_model]")) modelHint.textContent = sellLabels.manual;
        else modelHint.textContent = sellLabels.empty;
      }
      function roundToFive(value) { return Math.max(5, Math.round(value / 5) * 5); }
      function offerRange() {
        if (!state.reference) return null;
        var midpoint = state.reference.value * buybackRate * state.mul;
        return [roundToFive(midpoint * (1 - offerSpread)), roundToFive(midpoint * (1 + offerSpread))];
      }
      function formatEur(value) { return Math.round(value).toLocaleString("bg-BG") + " €"; }
      function fillSellForm() {
        var contact = val("[data-rt-field=rt_contact]");
        
        var r = offerRange();
        setHidden("[data-sell-email]", contact);
        setHidden("[data-sell-name]", val("[data-rt-field=rt_name]"));
        setHidden("[data-sell-phone]", val("[data-rt-field=rt_phone]"));
        var offerText = r ? r[0] + "–" + r[1] + " €" : "Ръчна оценка — няма надеждна ценова база";
        var referenceText = state.reference ? formatEur(state.reference.value) + " / " + state.reference.source : "няма";
        setHidden("[data-sell-body]", "Заявка за изкупуване от сайта (Продай компонент)\n\nТип: " + state.typeLabel + "\nСъстояние: " + state.condLabel + "\nМодел: " + val("[data-rt-field=rt_model]") + "\nПроизводител / версия: " + val("[data-rt-field=rt_manufacturer]") + "\nVRAM GB: " + (state.type === 'gpu' ? val('[data-rt-field=rt_vram]') : '') + "\nГаранция / покупка: " + val('[data-rt-field=rt_warranty]') + "\nДокументи / кутия: " + val('[data-rt-field=rt_packaging]') + "\nДефекти / ремонти: " + (faultsInput ? faultsInput.options[faultsInput.selectedIndex].text : '') + "\nИме: " + val("[data-rt-field=rt_name]") + "\nКонтакт: " + contact + "\nТелефон: " + val("[data-rt-field=rt_phone]") + "\nЖелана цена EUR: " + val("[data-rt-field=rt_price]") + "\nМестоположение: " + val("[data-rt-field=rt_location]") + "\nЖелан ъпгрейд: " + val("[data-rt-field=rt_upgrade]") + "\nДопълнителни детайли: " + (val("[data-rt-field=rt_details]") || "няма") + "\nСнимки (линк): " + (val("[data-rt-field=rt_photos]") || "няма") + "\nЦенова база: " + referenceText + "\nОриентировъчна оферта: " + offerText);
      }
      function detailsValid() {
        var email=root.querySelector('[data-rt-field=rt_contact]');
        var phone=root.querySelector('[data-rt-field=rt_phone]');
        var price=root.querySelector('[data-rt-field=rt_price]');
        var photos=root.querySelector('[data-rt-field=rt_photos]');
        var validPhotos=!photos || !photos.value.trim() || photos.checkValidity();
        var photoError=root.querySelector('[data-photo-error]');
        if(photoError) photoError.hidden=validPhotos;
        if(photos) photos.setAttribute('aria-invalid',validPhotos?'false':'true');
        var phoneValue=phone?phone.value.trim():'';
        var digits=phoneValue.replace(/\D/g,'');
        var validPhone=!phoneValue || (/^\+?[\d\s().-]+$/.test(phoneValue) && digits.length>=7 && digits.length<=15);
        return Boolean(val('[data-rt-field=rt_model]') && val('[data-rt-field=rt_name]') && email && email.value.trim() && email.checkValidity() && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value.trim()) && validPhone && validPhotos && (!price || price.checkValidity()) && consentInput && consentInput.checked);
      }
      try { var upgrade=new URLSearchParams(location.search).get('upgrade');if(upgrade) root.querySelector('[data-rt-field=rt_upgrade]').value=upgrade; } catch(ignoreUpgrade) {}
      function canNext() {
        if (state.step === 0) return state.type && state.cond;
        if (state.step === 1) return detailsValid();
        return true;
      }
      function updateNav() { if (nextBtn) { nextBtn.disabled = !canNext(); } }
      function render() {
        steps.forEach(function (s, i) { var active = i === state.step; s.classList.toggle("on", active); s.hidden = !active; s.setAttribute("aria-hidden", active ? "false" : "true"); });
        if (bar) bar.style.width = ((state.step + 1) / 4 * 100) + "%";
        var progress = root.querySelector(".rt-progress");
        if (progress) progress.setAttribute("aria-valuenow", String(state.step + 1));
        if (counter) counter.textContent = "Стъпка " + (state.step + 1) + " / 4";
        rail.forEach(function (r, i) {
          r.classList.toggle("active", i === (state.step === 3 ? 1 : 0));
          r.classList.toggle("done", state.step === 3 && i === 0);
        });
        if (backBtn) backBtn.style.visibility = state.step > 0 && state.step < 3 ? "visible" : "hidden";
        if (nextBtn) nextBtn.style.display = state.step < 3 ? "" : "none";
        if (nextBtn) { var nl = nextBtn.querySelector("[data-next-label]"); if (nl) nl.textContent = state.step === 2 ? "Изпрати за оценка" : "Продължи"; }
        if (state.step === 2) renderOffer();
        if (sellForm) sellForm.classList.toggle("rt-sell-complete", state.step === 3);
        var navigation = root.querySelector("[data-wizard-navigation]");
        if (navigation) navigation.style.display = state.step === 3 ? "none" : "flex";
        if (lastTrackedStep !== state.step) {
          rtTrack("sell_wizard_step", { step: state.step + 1, component_type: state.type || "not_selected" });
          if (state.step === 2) {
            var range = offerRange();
            rtTrack("sell_offer_view", { automated: Boolean(range), currency: "EUR", offer_min: range ? range[0] : null, offer_max: range ? range[1] : null, component_type: state.type });
          }
          if (state.step === 3) rtTrack("sell_lead_success", { component_type: state.type || "unknown" });
          lastTrackedStep = state.step;
        }
        updateNav();
      }
      function renderOffer() {
        var upgradeSummary = root.querySelector('[data-sum-upgrade]');
        var upgradeRow = root.querySelector('[data-upgrade-review]');
        var requestedUpgrade = val('[data-rt-field=rt_upgrade]');
        if (upgradeSummary) upgradeSummary.textContent = requestedUpgrade;
        if (upgradeRow) upgradeRow.hidden = !requestedUpgrade;
        var photoSummary=root.querySelector('[data-sum-photos]');
        if(photoSummary) photoSummary.textContent=val('[data-rt-field=rt_photos]') || photoSummary.dataset.empty;
        updateReference();
        fillSellForm();
        var r = offerRange();
        var o = root.querySelector("[data-offer]");
        if (o) o.innerHTML = r ? r[0] + "–" + r[1] + ' <span style="font-size:28px">€</span>' : "След проверка";
        setText("[data-offer-type]", state.typeLabel); setText("[data-offer-cond]", state.condLabel);
        setText("[data-sum-model]", val("[data-rt-field=rt_model]") || "—"); setText("[data-sum-contact]", val("[data-rt-field=rt_contact]") || "—");
        setText("[data-sum-reference]", state.reference ? formatEur(state.reference.value) + " · " + state.reference.source : "Ще бъде проверена ръчно");
        setText("[data-sum-formula]", state.reference ? Math.round(buybackRate * 100) + "% изкупна база × " + Math.round(state.mul * 100) + "% състояние" : "Без автоматична цена");
      }
      function setText(sel, txt) { var el = root.querySelector(sel); if (el) el.textContent = txt; }
      function advanceWizard() {
        if (!canNext()) return;
        if (errEl) errEl.style.display = "none";
        if (state.step < 2) {
          state.step = Math.min(2, state.step + 1); render();
          window.scrollTo({ top: root.getBoundingClientRect().top + window.scrollY - 90, behavior: "smooth" });
          return;
        }
        if (state.step === 2) {
          if(!detailsValid()){state.step=1;render();return;}
          if (!sellForm) {
            if (errEl) { errEl.style.display = ""; errEl.textContent = "Формата не може да бъде изпратена в момента. Опитай отново."; }
            return;
          }
          fillSellForm();
          rtTrack("sell_lead_submit", { component_type: state.type || "unknown", automated_offer: Boolean(offerRange()) });
          var nl = nextBtn ? nextBtn.querySelector("[data-next-label]") : null;
          if (nl) nl.textContent = "Изпращане…";
          finalSubmitting = true;
          nextBtn.type = "submit";
          if (sellForm.requestSubmit) sellForm.requestSubmit(nextBtn);
          else sellForm.submit();
        }
      }
      if (nextBtn) nextBtn.addEventListener("click", function (ev) {
        if (finalSubmitting) {ev.preventDefault();return;}
        ev.preventDefault();
        advanceWizard();
      });
      if (sellForm) sellForm.addEventListener("submit", function (ev) {
        if (finalSubmitting) return;
        ev.preventDefault();
        advanceWizard();
      });
      if (backBtn) backBtn.addEventListener("click", function () { state.step = Math.max(0, state.step - 1); render(); });
      var resetBtn = root.querySelector("[data-rt-reset]");
      if (resetBtn) resetBtn.addEventListener("click", function () { finalSubmitting = false; lastTrackedStep = -1; if (nextBtn) nextBtn.type = "button"; state = { step: 0, type: null, typeLabel: "", cond: null, condLabel: "", mul: 1, reference: null }; root.querySelectorAll(".on").forEach(function (x) { if (x.hasAttribute("data-type") || x.hasAttribute("data-cond")) x.classList.remove("on"); }); root.querySelectorAll("[data-type], [data-cond]").forEach(function (x) { x.setAttribute("aria-pressed", "false"); }); root.querySelectorAll(".rt-input").forEach(function (i) { i.value = ""; }); if (consentInput) consentInput.checked = false; refreshModelList(); updateReference(); if (window.history && window.history.replaceState) { window.history.replaceState(null, "", window.location.pathname); } render(); });
      if (root.querySelector("[data-rt-posted]")) { state.step = 3; }
      render();
    }
  });
})();
(function () {
  function setupLiveSearch() {
    document.querySelectorAll('[data-rt-live-search]').forEach(function (form) {
      if (form.dataset.liveReady) return;
      form.dataset.liveReady = 'true';
      var input = form.querySelector('input[name="q"]');
      var clearButton = form.querySelector('[data-rt-live-clear]');
      var panel = form.querySelector('[data-rt-live-panel]');
      var list = form.querySelector('[data-rt-live-list]');
      var status = form.querySelector('[data-rt-live-status]');
      var timer, blurTimer, controller, sequence = 0, active = -1, composing = false;
      function close() {
        clearTimeout(timer);
        sequence++;
        if (controller) controller.abort();
        panel.hidden = true;
        input.setAttribute('aria-expanded', 'false');
        input.removeAttribute('aria-activedescendant');
        active = -1;
      }
      function update() {
        if (clearButton) clearButton.hidden = !input.value;
        close();
        var query = input.value.trim();
        if (query.length < 2 || composing) return;
        var allUrl = new URL(form.action, location.origin);
        allUrl.searchParams.set('q', query);
        allUrl.searchParams.set('type', 'product');
        allUrl.searchParams.set('options[prefix]', 'last');
        form.querySelector('[data-rt-live-all]').href = allUrl.href;
        var request = sequence;
        list.replaceChildren();
        status.textContent = form.dataset.loading;
        panel.hidden = false;
        input.setAttribute('aria-expanded', 'true');
        timer = setTimeout(async function () {
          controller = new AbortController();
          var url = new URL(form.action, location.origin);
          url.searchParams.set('q', query);
          url.searchParams.set('type', 'product');
          url.searchParams.set('options[prefix]', 'last');
          url.searchParams.set('section_id', 'rt-live-results');
          try {
            var response = await fetch(url, {signal:controller.signal});
            if (!response.ok) throw new Error('Search unavailable');
            var html = await response.text();
            if (request !== sequence) return;
            var result = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-rt-live-response]');
            if (!result) throw new Error('Search unavailable');
            var links = result.querySelectorAll('.rt-live-result');
            links.forEach(function (link, index) {link.id = input.id + '-option-' + index;list.appendChild(link);});
            status.textContent = result.querySelector('[data-rt-live-message]').textContent;
          } catch (error) {
            if (request !== sequence || error.name === 'AbortError') return;
            status.textContent = form.dataset.error;
          }
        }, 220);
      }
      input.addEventListener('input', update);
      if (clearButton) clearButton.addEventListener('click', function () {input.value = '';update();input.focus();});
      input.addEventListener('focus', function () {if (input.value.trim().length >= 2 && panel.hidden) update();});
      input.addEventListener('compositionstart', function () {composing = true;close();});
      input.addEventListener('compositionend', function () {composing = false;update();});
      input.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {event.preventDefault();close();return;}
        var links = list.querySelectorAll('.rt-live-result');
        if (panel.hidden || !links.length || composing) return;
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
          event.preventDefault();
          active = (active + (event.key === 'ArrowDown' ? 1 : -1) + links.length) % links.length;
          links.forEach(function (link, index) {link.setAttribute('aria-selected', index === active ? 'true' : 'false');});
          input.setAttribute('aria-activedescendant', links[active].id);
          links[active].scrollIntoView({block:'nearest'});
        } else if (event.key === 'Enter' && active >= 0) {event.preventDefault();location.assign(links[active].href);}
      });
      document.addEventListener('pointerdown', function (event) {if (!form.contains(event.target)) close();});
      form.addEventListener('focusin', function () {clearTimeout(blurTimer);});
      form.addEventListener('focusout', function (event) {if (!form.contains(event.relatedTarget)) blurTimer = setTimeout(function () {if (!form.contains(document.activeElement)) close();}, 150);});

    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setupLiveSearch);else setupLiveSearch();
  document.addEventListener('shopify:section:load', setupLiveSearch);
})();
